(function () {
  function isProductPage() {
    return document.querySelector('[data-template*="product"]') || location.pathname.includes('/products/');
  }

  /* ---------------- Add to cart guard ---------------- */
  document.addEventListener('click', function (e) {
    const addBtn = e.target.closest('button[name="add"], button.add-to-cart, button[data-add-to-cart], button[type="submit"][form]');
    if (!addBtn) return;

    const form = addBtn.closest('form') || document.getElementById(addBtn.getAttribute('form'));
    if (!form) return;

    form.setAttribute('enctype', 'multipart/form-data');

    const qty = form.querySelector('input[name="quantity"]');
    if (qty) {
      const minAttr = qty.getAttribute('data-min-qty') || qty.getAttribute('min') || '1';
      const min = parseInt(minAttr, 10) || 1;
      const val = parseInt(qty.value || '1', 10) || min;
      if (val < min) qty.value = min;
    }

    const photoWrap = form.querySelector('.product-photo-upload[data-photo-required="true"]');
    if (photoWrap) {
      const fileInput = photoWrap.querySelector('input[type="file"][name^="properties["]');
      if (!fileInput || !fileInput.files || !fileInput.files.length) {
        e.preventDefault();
        alert('Lütfen ürüne ait fotoğrafı yükleyin.');
        if (fileInput) fileInput.focus();
      }
    }
  }, true);

  /* ---------------- Quantity Fix (99 sonrası 50 yapma sorununu çözer) ---------------- */
  ['input', 'change'].forEach(function(eventType) {
    document.addEventListener(eventType, function (e) {
      const qty = e.target.closest('input[name="quantity"]');
      if (qty) {
        const minAttr = qty.getAttribute('data-min-qty') || qty.getAttribute('min') || '1';
        const min = parseInt(minAttr, 10) || 1;
        const val = parseInt(qty.value, 10);

        if (eventType === 'change' && (isNaN(val) || val < min)) {
          qty.value = min;
        } else if (eventType === 'input' && !isNaN(val) && val < min) {
          qty.value = min;
        }
      }

      if (eventType === 'change') {
        const fileInput = e.target.closest('.product-photo-upload input[type="file"][name^="properties["]');
        if (!fileInput) return;

        const wrap = fileInput.closest('.product-photo-upload');
        const nameEl = wrap && wrap.querySelector('.file-name');
        const preview = wrap && (
          wrap.querySelector('.product-photo-upload__preview') ||
          wrap.querySelector('img[alt*="Yüklenen görsel ön izlemesi"]')
        );

        const file = fileInput.files && fileInput.files[0];

        if (!file) {
          if (nameEl) nameEl.textContent = 'Dosya seçilmedi';
          if (preview) { preview.style.display = 'none'; preview.removeAttribute('src'); }
          return;
        }

        const MAX = 15 * 1024 * 1024;
        if (file.size > MAX) {
          alert('Dosya boyutu 15 MB’dan büyük. Lütfen daha küçük bir dosya yükleyin.');
          fileInput.value = '';
          if (nameEl) nameEl.textContent = 'Dosya seçilmedi';
          if (preview) { preview.style.display = 'none'; preview.removeAttribute('src'); }
          return;
        }

        if (nameEl) nameEl.textContent = file.name;
        if (preview) {
          preview.src = URL.createObjectURL(file);
          preview.style.display = 'block';
        }
      }
    });
  });

  /* ---------------- Sepet Adet Kontrolü ---------------- */
  document.addEventListener('input', function (e) {
    const inp = e.target.closest('input[type="number"][name="updates[]"]');
    if (!inp) return;
    const minAttr = inp.getAttribute('data-min-qty') || inp.getAttribute('min') || '1';
    const min = parseInt(minAttr, 10) || 1;
    const val = parseInt(inp.value, 10);
    if (!isNaN(val) && val < min) inp.value = min;
  });

  /* ---------------- DOM READY (Layout & Form Kontrolleri) ---------------- */
  document.addEventListener('DOMContentLoaded', function () {
    if (!isProductPage()) return;

    document.querySelectorAll('form[action^="/cart/add"]').forEach(function (form) {
      var qtyInput = form.querySelector('input[name="quantity"]');
      if (!qtyInput) return;

      var minAttr = qtyInput.getAttribute('data-min-qty') || qtyInput.getAttribute('min') || '1';
      var minQty = parseInt(minAttr, 10) || 1;

      function normalizeQty() {
        var val = parseInt(qtyInput.value, 10);
        if (isNaN(val) || val < minQty) {
          qtyInput.value = minQty;
          return false;
        }
        return true;
      }

      qtyInput.addEventListener('change', normalizeQty);

      form.addEventListener('submit', function (e) {
        if (!normalizeQty()) {
          e.preventDefault();
          alert('Bu ürün için minimum sipariş adedi: ' + minQty);
        }
      });
    });

    document.querySelectorAll('form[action^="/cart/add"]').forEach(function (form) {
      form.querySelectorAll('label, legend').forEach(function (lbl) {
        var txt = (lbl.textContent || '').toLowerCase().replace(/\s+/g, ' ').trim();
        if (!txt) return;

        if (txt.includes('ek notlarınız')) {
          var blk =
            lbl.closest('.product-form__input') ||
            lbl.closest('.product-form__field') ||
            lbl.closest('.product-form__fields') ||
            lbl.parentElement;

          if (blk && blk.parentNode) {
            blk.parentNode.removeChild(blk);
          }
        }
      });
    });

    document.querySelectorAll('form[action^="/cart/add"]').forEach(function (form) {
      var extras = [];

      var yazilarLabel = Array.from(form.querySelectorAll('label, legend')).find(function (lbl) {
        var t = (lbl.textContent || '').toLowerCase().replace(/\s+/g, ' ').trim();
        return t.includes('üzerine yazılmasını istediğiniz yazılar');
      });

      if (yazilarLabel) {
        var yazilarBlk =
          yazilarLabel.closest('.product-form__input') ||
          yazilarLabel.closest('.product-form__field') ||
          yazilarLabel.closest('.product-form__fields') ||
          yazilarLabel.parentElement;
        if (yazilarBlk) extras.push(yazilarBlk);
      }

      var photo = form.querySelector('.product-photo-upload');
      if (photo) extras.push(photo);

      if (!extras.length) return;

      var anchor = form.querySelector(
        '.product-form-buttons--stacked, .product-form__buttons, .product-form-buttons, quantity-selector-component, .quantity-selector'
      );

      if (!anchor || !anchor.parentNode) return;

      var parent = anchor.parentNode;

      parent.style.display = 'flex';
      parent.style.flexDirection = 'column';
      parent.style.alignItems = 'stretch';
      if (!parent.style.gap) parent.style.gap = '12px';

      extras.forEach(function (el) {
        if (!el) return;
        parent.insertBefore(el, anchor);
        el.style.width = '100%';
        el.style.maxWidth = '100%';
        el.style.display = 'block';
      });
    });

  });
})();